const WHATSAPP_URL =
  'https://wa.me/5215561375437?text=Hola%2C%20vi%20su%20p%C3%A1gina%20de%20Infraestructuras%20HO%20LAASKS%20y%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios.';

export default function WhatsAppButton() {
  return (
    <>
      <style>{`
        @keyframes whatsapp-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5), 0 4px 16px rgba(0,0,0,0.18); }
          50% { box-shadow: 0 0 0 12px rgba(37, 211, 102, 0), 0 4px 16px rgba(0,0,0,0.18); }
        }
        .whatsapp-btn {
          animation: whatsapp-pulse 2.8s ease-in-out infinite;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .whatsapp-btn:hover {
          transform: scale(1.12);
          animation: none;
          box-shadow: 0 8px 28px rgba(37, 211, 102, 0.45), 0 4px 16px rgba(0,0,0,0.18);
        }
        .whatsapp-tooltip {
          opacity: 0;
          pointer-events: none;
          transform: translateX(8px);
          transition: opacity 0.2s ease, transform 0.2s ease;
        }
        .whatsapp-wrapper:hover .whatsapp-tooltip {
          opacity: 1;
          transform: translateX(0);
        }
      `}</style>

      <div className="whatsapp-wrapper fixed bottom-6 right-6 z-50 flex items-center gap-3">
        {/* Tooltip */}
        <div className="whatsapp-tooltip bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap shadow-lg">
          Contáctanos por WhatsApp
          <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-900" />
        </div>

        {/* Botón */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contáctanos por WhatsApp"
          className="whatsapp-btn w-14 h-14 rounded-full flex items-center justify-center cursor-pointer"
          style={{ backgroundColor: '#25D366' }}
        >
          {/* Ícono WhatsApp SVG oficial */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="30"
            height="30"
            fill="white"
            aria-hidden="true"
          >
            <path d="M16.003 2.667C8.637 2.667 2.667 8.637 2.667 16c0 2.363.627 4.674 1.817 6.693L2.667 29.333l6.82-1.787A13.27 13.27 0 0 0 16.003 29.333C23.37 29.333 29.333 23.363 29.333 16S23.37 2.667 16.003 2.667zm0 24.267a11.01 11.01 0 0 1-5.617-1.543l-.403-.24-4.047 1.06 1.08-3.94-.263-.413A10.987 10.987 0 0 1 5.003 16c0-6.067 4.933-11 11-11s11 4.933 11 11-4.933 11-11 11zm6.04-8.24c-.33-.167-1.953-.963-2.257-1.073-.303-.11-.523-.167-.743.167-.22.33-.853 1.073-1.047 1.293-.193.22-.387.247-.717.083-.33-.167-1.393-.513-2.653-1.637-.98-.873-1.643-1.953-1.837-2.283-.193-.33-.02-.51.147-.673.15-.147.33-.387.497-.58.167-.193.22-.33.33-.55.11-.22.057-.413-.027-.58-.083-.167-.743-1.793-1.017-2.453-.267-.643-.54-.557-.743-.567l-.633-.013c-.22 0-.577.083-.88.413-.303.33-1.153 1.127-1.153 2.747s1.18 3.187 1.343 3.407c.167.22 2.32 3.54 5.62 4.967.787.34 1.4.543 1.877.693.787.25 1.503.217 2.07.133.633-.093 1.953-.797 2.23-1.567.277-.77.277-1.43.193-1.567-.083-.137-.303-.22-.633-.387z" />
          </svg>
        </a>
      </div>
    </>
  );
}
